import { CustomDate } from 'shared/utils';
import { layerTypeResponseMapping } from '../layers/helpers';
import type { ApiResponse } from '../types';
import { apiDataResponseMapper } from '../utils';
import type { WorkspaceMappedResponse, WorkspaceResponseLayer } from './types';

export const workspaceResponseMapper = (
  response: ApiResponse<WorkspaceMappedResponse>,
) => {
  const mappedResponse = apiDataResponseMapper<
    WorkspaceMappedResponse,
    WorkspaceMappedResponse
  >(response.data);

  mappedResponse.workspaceLayers =
    mappedResponse.workspaceLayers.map<WorkspaceResponseLayer>(
      ({ type, createdAt, iteration, ...rest }) => ({
        ...rest,
        type: layerTypeResponseMapping[type],
        createdAt: new CustomDate(createdAt),
        iteration: {
          ...iteration,
          date: new CustomDate(iteration.date),
        },
      }),
    );

  mappedResponse.terrainIteration.date = new CustomDate(
    mappedResponse.terrainIteration.date,
  );

  return mappedResponse;
};
